import { Expose, Type } from "class-transformer";

export default class MarketingMailRes {
  @Expose() readonly sendMarktingMailId!: number;
  @Type(() => Date)
  @Expose()
  readonly createdAt!: Date;
  @Expose() readonly email!: string;
}
